import type { UserData } from '../context/UserContext'

// "Sample state": the user's active organisation is their personal sample organisation.
export const isSampleState = (userData?: Pick<UserData, 'access'> | null) =>
	userData?.access?.fictitiousKind === 'sample'

// Sidebar sections offered in sample state; everything else (insights, supplier invitations, public
// report search, reports, data hub) is hidden. Bottom items (help, settings) always stay. UX only.
const SAMPLE_MENU_PATH_PREFIXES = ['/dashboard', '/purchases']

export const isSampleMenuPath = (path: string) =>
	SAMPLE_MENU_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(prefix + '/'))

// The user has hidden sample/demo/training organisations and has no real one, so there is nothing to show.
export const hasNoVisibleOrganisation = (
	userData?: Pick<UserData, 'memberships' | 'showFictitiousOrganisations'> | null
) => {
	const memberships = userData?.memberships ?? []
	return (
		userData?.showFictitiousOrganisations === false &&
		memberships.length > 0 &&
		memberships.every((membership) => membership.fictitiousKind)
	)
}
